import { type Destination, Logger } from '@avodah-inc/med-logger';

let _logger: Logger | undefined;
let _browserInitialized = false;

function isBrowser(): boolean {
  return typeof window !== 'undefined';
}

/**
 * Returns the singleton Logger instance.
 *
 * Server (Node runtime): stdout → Datadog Agent. Always ready.
 * Client (browser): silent no-op until {@link initBrowserLogger} called
 *   in a `useEffect` on the root layout. Prevents SSR/hydration crashes.
 *
 *   `import { getLogger } from "~/lib/logger";`
 *   `const logger = getLogger();`
 */
export function getLogger(): Logger {
  if (!_logger) {
    if (isBrowser()) {
      _logger = new Logger('nsight_web', undefined, { logLevel: 'silent' });
    } else {
      _logger = new Logger('nsight_web');
    }
  }
  return _logger;
}

/**
 * Switches the browser Logger to write to `destination`.
 * No-op on server. Idempotent.
 * Called once at app bootstrap by `<DatadogInit />`.
 */
export function initBrowserLogger(destination: Destination): void {
  if (!isBrowser() || _browserInitialized) return;
  _browserInitialized = true;

  _logger = new Logger('nsight_web', destination, { logLevel: 'info' });
}
